export default class Flipbook {
    constructor() {
        this.section = document.querySelector('.flipbook');
        this.close = this.section.querySelector('.close');

        this.openModal = document.querySelectorAll("[href='javascript:(openModalFlipBook)']");
        
        this.ready();
    }

    ready() {

        this.openModal.forEach(button => {
            button.addEventListener('click', () => {
                this.section.classList.add('active')
            })
        })

        this.close.addEventListener('click', () => {
            this.section.classList.remove('active')
        })
        
    }
}

if (document.querySelector('.flipbook')) {
    new Flipbook();
}